import {useState} from "react";
import * as React from "react";

const SlackWorkspacesTable = () => {
    const [loaded, setLoaded] = useState(false);
    const [workspaces, setWorkspaces] = useState([]);

    if (loaded) {
        const items = workspaces.map((workspace) => {
            return <div id={"slack_workspace_" + workspace.id} key={"slack_workspace_" + workspace.id} className="slackWorkspacesTable__item">
                <img src={workspace.icon.image_44} className={"slackWorkspacesTable__icon"} alt=""/>
                {workspace.name}
            </div>
        });

        if (!items.length) {
            return null;
        }

        return <React.Fragment>

            <h5 className={"slackWorkspacesActive"}>Active Slack integrations</h5>

            <div className={"slackWorkspacesTable"}>
                {items}
            </div>

        </React.Fragment>
    }
    else {
        maxkir.AjaxRequest("/slack/workspaces", {
            method: "get",
            onSuccess: function(response) {
                setWorkspaces(response.responseJSON)
                // setWorkspaces([
                //     {
                //         id: "test",
                //         name: "test",
                //         icon: {
                //             "image_34": "https://...",
                //             "image_44": "https://...",
                //         }
                //     }
                // ])
            },
            onComplete: () => {
                setLoaded(true);
            }
        })

        return null
    }
}

export {SlackWorkspacesTable};
